export default __webpack_public_path__ + "locales/en/InviteDialog.json?hash=dde8225a55a78843f549876209ec89b3";